<script setup lang="ts">
/**
 * A titled group of rows. Capped at a readable width unless `wide`.
 * `platform` keeps it to the desktop or the phone app only.
 */
import { onThisPlatform, type AppPlatform } from '../../../utils/appVariant'

defineProps<{
  title: string
  intro?: string
  wide?: boolean
  platform?: AppPlatform
}>()
</script>

<template>
  <section v-if="onThisPlatform(platform)" class="s-section" :class="{ wide }">
    <header class="s-section-head">
      <h3 class="s-section-title">{{ title }}</h3>
      <div v-if="$slots.actions" class="s-section-actions">
        <slot name="actions" />
      </div>
    </header>
    <p v-if="intro || $slots.intro" class="s-section-intro">
      <slot name="intro">{{ intro }}</slot>
    </p>
    <slot />
  </section>
</template>
